/**
 * Created by chenqifeng on 2016/8/31.
 */

import $ from 'jquery';
import maple from 'maple';

import {request} from '../http';
import domain from '../domain';

import mallList from '../../../../setting/mallShop.json';
import marketList from '../../../../setting/marketShop.json';

var DistrService = function(){
    if(domain.env === 'online'){
        this.domain = "//distr.51tiangou.com";
    }else{
        this.domain = "//distr." + domain.env + ".66buy.com.cn";
    }
};

DistrService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    return request(params);
};

DistrService.prototype.getJudgeDistribution = function(params){
	params.type = 'GET';
	this._serviceAjaxCom("/public/getJudgeDistribution", params);
}

export default new DistrService();